<template>
    <div class="money-code-container">
        <div class="main">
            <div class="img-box">
                <img src="https://cdn.bigbays.cn/pc/home/gongzhonghao.jpg" alt="">
            </div>
            <p class="code-name">转发分钱码</p>
            <p class="rule">查看规则</p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'MoneyCode',
    data() {
        return {}
    }
}
</script>
<style lang="scss" scoped>
@import './MoneyCode.scss';
</style>


// WEBPACK FOOTER //
// src/components/pc/common/qr-code/MoneyCode.vue